export default __webpack_public_path__ + "static/media/4.dae49c54.jpg";